import React, { useEffect, useState } from 'react'
import { AiOutlineDeliveredProcedure } from 'react-icons/ai';
import { FaTruck } from 'react-icons/fa';
import { FiRefreshCcw } from 'react-icons/fi';
import { IoToday } from "react-icons/io5";
import { MdOutlineCancel } from "react-icons/md";
import { fetchAllDataAPI } from '../../utils/api';
import { toast } from 'react-toastify';

const DUMMY_DATA = {
    neworder: 124,
    abandoned: 38,
    delivered: 856,
    process: 67,
    totalorder: 1128,
};

const DashboardOverview = () => {
    const subagentid = localStorage.getItem('subagentdata');
    const [data, setData] = useState(DUMMY_DATA); // ✅ Fallback dummy data by default
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDashboardAllOrderTypeAgentOrder();
    }, [subagentid]);

    const getDashboardAllOrderTypeAgentOrder = () => {
        fetchAllDataAPI('sub-get-get-dashboard-all-order-type-data')
            .then((res) => {
                if (res.data.status === 1) {
                    setData({
                        neworder: res.data.neworder,
                        abandoned: res.data.abandoned,
                        delivered: res.data.delivered,
                        process: res.data.process,
                        totalorder: res.data.totalorder,
                    });
                } else {
                    toast.warning("Using demo data — check your connection");
                }
            })
            .catch(() => {
                toast.warning("Could not load overview data");
            })
            .finally(() => setLoading(false));
    };

    const cards = [
        {
            label: "New Orders",
            value: data.neworder,
            icon: <IoToday />,
            bg: "#4e9191",
        },
        {
            label: "Abandoned Orders",
            value: data.abandoned,
            icon: <MdOutlineCancel />,
            bg: "#e74c3c",
        },
        {
            label: "Order Processing",
            value: data.process,
            icon: <FaTruck />,
            bg: "#00CED1",
        },
        {
            label: "Order Delivered",
            value: data.delivered,
            icon: <AiOutlineDeliveredProcedure />,
            bg: "#c779db",
        },
        {
            label: "Total Orders",
            value: data.totalorder,
            icon: <IoToday />,
            bg: "#597e0d",
        },
    ];

    return (
        <div className="dashboardoverview">
            {cards.map((card, index) => (
                <div key={index} className="card radius-10 overflow-hidden w-100">
                    <div className="d-flex overbody">
                        <div className="icons" style={{ background: card.bg }}>
                            {card.icon}
                        </div>
                        <div className="ordertype">
                            <p>{card.label}</p>
                            <h2>
                                {loading ? (
                                    <span style={{
                                        display: "inline-block",
                                        width: "50px", height: "20px",
                                        background: "#eee", borderRadius: "4px",
                                        animation: "pulse 1.5s infinite"
                                    }} />
                                ) : (
                                    card.value ?? 0
                                )}
                            </h2>
                        </div>
                    </div>
                </div>
            ))}

            {/* Pulse animation for loading skeleton */}
            <style>{`
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
            `}</style>
        </div>
    );
};

export default DashboardOverview;